// ─── DICTIONNAIRE FR / EN ──────────────────────────────────────────────────────
// Toutes les chaînes visibles par l'utilisateur. Les valeurs internes (v:)
// du funnel ne changent PAS entre langues — seuls les labels affichés changent.

export const strings = {

  // ── Application ──────────────────────────────────────────────────────────────
  fr: {
    app_title:        "Croisière AI",
    app_tagline:      "Votre agent IA — croisière, vols et hôtel en quelques minutes.",
    live_badge:       "EN DIRECT",

    // ── Welcome ────────────────────────────────────────────────────────────────
    welcome_hero_alt: "Port de croisière",
    welcome_start:    "📋 Répondre aux questions →",
    welcome_how:      "Comment voulez-vous commencer ?",
    welcome_form_sub: "Formulaire guidé · ~8 questions",
    welcome_or:       "ou",
    welcome_cta_sub:  "✓ 2 recherches gratuites/mois · 1re sans compte requis",
    welcome_bullets: [
      "🔍 Recherche web en temps réel — prix du jour, pas un catalogue",
      "✈️ Vols + hôtel la veille inclus dans chaque recommandation",
      "🧠 Les meilleures offres selon vos critères, classées et justifiées",
    ],
    welcome_disclaimer: "Aucune carte de crédit requise · Propulsé par Claude (Anthropic)",

    // ── Searching screen ───────────────────────────────────────────────────────
    searching_cruise:  "Recherche de croisières",
    searching_cruise_d:"Analyse des disponibilités et des prix en temps réel…",
    searching_footer:  "Notre IA vérifie chaque croisière en temps réel — comptez jusqu'à 1 minute. Surtout ne rafraîchissez pas la page, on y est presque !",
    searching_flights: "Recherche de vols",
    searching_flights_d:"Meilleurs tarifs aériens vers le port d'embarquement…",
    searching_hotel:   "Recherche d'hôtel",
    searching_hotel_d: "Hébergement avec navette aéroport et navette port…",
    searching_results: "Analyse et préparation des résultats",
    searching_results_d:"Comparaison, classement et mise en forme de votre sélection…",
    searching_cancel:  "Annuler",
    analyse_steps: [
      "Je compare les itinéraires et les escales…",
      "Je vérifie le prix réel de chaque départ…",
      "Je calcule les vols et l'hôtel la veille…",
      "Je classe les meilleures offres pour toi…",
      "Je rédige ton analyse personnalisée…",
    ],

    // ── Tips ───────────────────────────────────────────────────────────────────
    tips: [
      "💡 Réserver 6 à 9 mois à l'avance donne souvent les meilleurs prix — surtout pour les grandes cabines.",
      "💡 Le mardi et le mercredi sont les meilleurs jours pour trouver des promotions flash.",
      "💡 CruiseDirect offre les mêmes avantages que Costco.ca — sans avoir besoin d'un abonnement Costco.",
      "💡 Les cabines intérieures peuvent coûter 40% moins cher — idéal si vous passez vos journées à explorer.",
      "💡 Sur un méga-paquebot, la cabine Boardwalk donne sur le parc d'attractions — très animé le soir.",
      "💡 Arriver la veille de l'embarquement évite le stress des retards de vol — un soir d'hôtel bien investi.",
      "💡 Les promotions « Kids Sail Free » de Royal Caribbean peuvent économiser des milliers de dollars en famille.",
      "💡 Si vous êtes à distance raisonnable d'un port, conduire élimine le coût des vols.",
    ],

    // ── Funnel navigation ──────────────────────────────────────────────────────
    next:       "Suivant →",
    back:       "← Retour",
    search:     "🔍 Lancer la recherche",
    select_multiple: "Sélectionnez tout ce qui s'applique",
    optional:   "(optionnel)",
    skip:       "Passer",

    // ── Funnel steps ───────────────────────────────────────────────────────────
    steps: {
      experience: {
        q:   "Quelle est votre expérience des croisières ?",
        sub: "Cela guide notre approche de recherche.",
        opts: {
          first:  { l: "Première croisière",  s: "Je n'ai jamais navigué" },
          some:   { l: "Quelques croisières",  s: "2 à 4 expériences" },
          expert: { l: "Croisiériste aguerri",  s: "5 croisières et plus" },
        },
      },
      vibe: {
        q:   "Quelle ambiance recherchez-vous ?",
        sub: "Nous choisirons la meilleure compagnie selon votre style.",
        opts: {
          party:     { l: "Festif & animé",  s: "Piscines, spectacles, bars" },
          family:    { l: "Famille",          s: "Activités pour tous les âges" },
          romantic:  { l: "Romantique",       s: "Raffiné, paisible, gastronomie" },
          adventure: { l: "Aventure",         s: "Sports, excursions, nature" },
        },
      },
      intent: {
        q:   "Avez-vous quelque chose de précis en tête ?",
        sub: "Les priorités que vous classerez plus loin guideront Claude.",
        opts: {
          value:   { l: "Je suis ouvert à tout",   s: "Surprenez-moi — les priorités que je classerai guideront la recherche" },
          company: { l: "Une compagnie en tête",   s: "J'ai une compagnie que je veux explorer" },
          by_ship: { l: "Un navire précis",        s: "Je sais exactement quel bateau je veux" },
        },
      },
      regions: {
        q:   "Quelle destination vous attire ?",
        sub: "Sélectionnez une ou plusieurs régions.",
        opts: {
          carib_east:  { l: "Caraïbes Est",      s: "Puerto Rico, USVI, St-Martin, Bahamas" },
          carib_west:  { l: "Caraïbes Ouest",     s: "Mexique, Jamaïque, Grand Cayman, Belize" },
          carib_south: { l: "Caraïbes Sud",       s: "Aruba, Curaçao, Barbade, Îles du Vent" },
          repositioning: { l: "Repositionnement / Traversée", s: "À sens unique, saisonnier (printemps/automne), départs limités" },
          bermuda:     { l: "Bermudes",            s: "Île unique, eaux turquoise, British charm" },
          europe_med:     { l: "Méditerranée",              s: "Barcelone, Rome, Grèce, Croatie" },
          europe_north:   { l: "Europe du Nord & Baltique", s: "Copenhague, Stockholm, fjords norvégiens" },
          europe_british: { l: "Îles britanniques & Islande", s: "Royaume-Uni, Irlande, Reykjavik" },
          alaska:      { l: "Alaska",              s: "Glaciers, fjords, faune sauvage" },
          hawaii:      { l: "Hawaï / Pacifique",   s: "Îles hawaïennes, Polynésie" },
          asia:        { l: "Asie",                s: "Japon, Vietnam, Singapour, Dubaï" },
          any:         { l: "Peu importe",         s: "Surprenez-moi — meilleure offre" },
        },
      },
      ports: {
        q:   "Une île ou une escale en particulier ?",
        sub: "Optionnel — ex. Aruba, Curaçao, Bonaire. Laissez vide si peu importe.",
      },
      sea_days_pref: {
        q:   "Ports ou jours en mer — votre préférence ?",
        sub: "Deux croisières identiques peuvent offrir des rythmes très différents.",
        opts: {
          max_ports: { l: "Maximum de ports",       s: "1–2 jours en mer max — explorer à chaque escale" },
          balanced:  { l: "Équilibré",               s: "Alternance ports et détente en mer" },
          sea_days:  { l: "Jours en mer bienvenus",  s: "J'apprécie le bateau autant que les ports" },
          any:       { l: "Peu importe",             s: "L'itinéraire global prime" },
        },
      },
      port_activities: {
        q:   "Qu'aimez-vous faire dans les ports ?",
        sub: "Guide le choix des itinéraires — sélectionnez tout ce qui s'applique.",
        opts: {
          beach:     { l: "Plage & baignade",    s: "Sable, snorkeling, eaux cristallines" },
          culture:   { l: "Histoire & culture",  s: "Sites historiques, villes coloniales, musées" },
          food:      { l: "Gastronomie locale",  s: "Marchés, restaurants, cuisine authentique" },
          shopping:  { l: "Shopping",            s: "Duty-free, artisanat local, boutiques" },
          adventure: { l: "Sports & aventure",   s: "Kayak, randonnée, plongée, tyrolienne" },
          any:       { l: "Tout m'intéresse",    s: "Je décide selon les options disponibles" },
        },
      },
      companies: {
        q:   "Une compagnie en tête ?",
        sub: "Laissez vide pour chercher toutes les compagnies.",
      },
      company_for_ship: {
        q:   "De quelle compagnie ?",
        sub: "Réduit la liste des navires — laissez vide si vous n'êtes pas sûr.",
      },
      specific_ship: {
        q:   "Quel navire visez-vous ?",
        sub: "Sélectionnez le navire qui vous intéresse.",
      },
      ship_class: {
        q:   "Quelle classe de navire vous attire ?",
        sub: "La classe détermine l'ambiance, les activités et la clientèle.",
      },
      ship_freshness: {
        q:   "L'état du navire, c'est important pour vous ?",
        sub: "Neuf et rénové sont deux choses différentes.",
        opts: {
          recent: { l: "Récent ou rénové", s: "Mis à l'eau ou rénové dans les 5 dernières années" },
          any:    { l: "Peu importe",      s: "Les deals priment — bateau plus ancien OK" },
        },
      },
      cabin: {
        q:   "Quelle cabine préférez-vous ?",
        sub: "Type d'hébergement à bord — vous pouvez en sélectionner plusieurs.",
        opts: {
          balcony_ocean:       { l: "Balcon Océan",  s: "Vue sur la mer" },
          balcony_centralpark: { l: "Central Park",  s: "Jardin intérieur" },
          balcony_boardwalk:   { l: "Boardwalk",     s: "Vue parc d'attractions" },
          oceanview:           { l: "Vue Océan",     s: "Fenêtre sans balcon" },
          inside:              { l: "Intérieure",    s: "Si deal exceptionnel" },
          suite:               { l: "Suite",         s: "Occasion spéciale" },
        },
      },
      priorities: {
        q:   "Classez ces critères du plus au moins important.",
        sub: "Cliquez dans l'ordre — votre #1 guide notre scoring.",
        opts: {
          prix:       { l: "Prix / Budget",  s: "Meilleur rapport qualité-prix" },
          itineraire: { l: "Itinéraire",     s: "Ports, destinations, escales" },
          bateau:     { l: "Le bateau",      s: "Classe, taille, fraîcheur" },
          compagnie:  { l: "La compagnie",   s: "Fidélité, style, service à bord" },
          experience: { l: "Expérience à bord", s: "Ambiance, activités, gastronomie" },
        },
      },
      duration: {
        q:   "Quelle durée de croisière ?",
        sub: "La durée influence considérablement le prix.",
        opts: {
          short: { l: "Court  3–6 nuits",    s: "Long week-end prolongé" },
          week:  { l: "7 nuits exactement",  s: "La durée classique" },
          long:  { l: "Long  8 nuits+",      s: "Voyage immersif" },
          xlong: { l: "15 nuits et +",       s: "Grand voyage" },
          any:   { l: "Peu importe",         s: "Meilleure offre disponible" },
        },
        exactLabel: "Ou précisez le nombre de nuits :",
        exactPlaceholder: "ex: 14",
        exactHint: "Recherche centrée sur ce nombre exact (±1 nuit). Remplace la sélection ci-dessus.",
      },
      when: {
        q:   "Quand souhaitez-vous partir ?",
        sub: "Vos dates influencent les promotions disponibles.",
        opts: {
          exact:    { l: "Dates précises",     s: "Je sais quand je pars" },
          flexible: { l: "Flexible ±1–3 j",   s: "Autour de mes dates" },
          month:    { l: "Un mois précis",     s: "Je cible une période" },
          range:    { l: "Une plage de dates", s: "Entre deux dates — ex: juillet à août" },
          anytime:  { l: "La meilleure offre", s: "Surprenez-moi !" },
        },
      },
      dates: {
        q:   "Quelles sont vos dates ?",
        sub: "Sélectionnez votre date de départ.",
      },
      group: {
        q:   "Qui voyagera avec vous ?",
        sub: "Chaque voyageur compte pour les promotions.",
        opts: {
          solo:   { l: "Seul·e",  s: "Juste moi" },
          couple: { l: "En couple", s: "2 adultes" },
          family: { l: "Famille",   s: "Avec enfants" },
          group:  { l: "Groupe",    s: "Amis / famille élargie" },
        },
      },
      group_size: {
        q:   "Combien d'adultes dans le groupe ?",
        sub: "Détermine les prix et les options de cabines communicantes.",
        opts: {
          "3":  { l: "3 adultes",    s: "" },
          "4":  { l: "4 adultes",    s: "Cabines communicantes possibles" },
          "6":  { l: "5–6 adultes",  s: "Tarifs groupe disponibles" },
          "8":  { l: "7–8 adultes",  s: "Tarifs groupe avantageux" },
          "10": { l: "9 adultes +",  s: "Tarifs groupe — contactez une agence" },
        },
      },
      family_detail: {
        q:   "Parlez-moi de vos enfants.",
        sub: "Les âges déterminent les promotions disponibles.",
      },
      cabin_occupancy: {
        q:   "Une seule cabine ou plusieurs ?",
        sub: "À partir de 3 voyageurs, ça change les navires possibles et le prix par personne.",
        opts: {
          one:      { l: "Une seule cabine",      s: "Tout le monde dans la même cabine" },
          multiple: { l: "Plusieurs cabines",     s: "Réparti sur deux cabines ou plus" },
          unsure:   { l: "Je ne sais pas encore",  s: "Montrez-moi les options" },
        },
      },
      occasion: {
        q:   "Y a-t-il une occasion spéciale ?",
        sub: "On adapte nos recommandations de cabine et de compagnie.",
        opts: {
          honeymoon:   { l: "Lune de miel",           s: "Voyage de noces ou premier anniversaire" },
          anniversary: { l: "Anniversaire de mariage", s: "Occasion romantique" },
          birthday:    { l: "Anniversaire / Fête",     s: "Célébration en famille ou entre amis" },
          graduation:  { l: "Graduation / Retraite",   s: "Grande étape de vie" },
          none:        { l: "Pas d'occasion",          s: "Voyage régulier" },
        },
      },
      departure: {
        q:   "Comment arriverez-vous au port ?",
        sub: "Détermine les sources de recherche.",
        opts: {
          drive_ny:  { l: "En voiture",    s: "Je me rends au port par la route" },
          fly_south: { l: "En avion",      s: "L'IA trouve les meilleurs vols" },
          either:    { l: "Peu importe",   s: "Comparez les deux" },
        },
      },
      departure_port: {
        q:   "Quel port de départ vous convient ?",
        sub: "Choisissez le port d'où partira votre croisière.",
      },
      infant_flight_seat: {
        q:   "Pour le vol, votre bébé voyagera comment ?",
        sub: "Moins de 2 ans : sur les genoux (souvent gratuit ou taxes seulement) ou sur un siège réservé. Les 2 ans et plus prennent toujours leur propre siège.",
        opts: {
          lap:  { l: "Sur les genoux d'un parent", s: "Souvent gratuit (vol intérieur) ou taxes seulement" },
          seat: { l: "Sur un siège réservé",       s: "Bébé compté comme un passager (siège payant)" },
        },
      },
      drive_origin: {
        q:   "Où êtes-vous situé ?",
        sub: "Pour vous proposer une option en voiture et une option en avion.",
        opts: {
          mtl:    { l: "Montréal / Québec", s: "Cape Liberty (NY) et Boston à ~5–7 h de route" },
          ottawa: { l: "Ottawa / Kingston",  s: "Cape Liberty (NY) et Boston à ~6–8 h de route" },
          toronto:{ l: "Toronto / Ontario",  s: "Ports du Nord-Est à 9 h+ — mieux vaut voler" },
          autres: { l: "Autre région",       s: "Toutes les options en avion" },
        },
      },
      flight_type: {
        q:   "Quel type de vol préférez-vous ?",
        sub: "Le direct élimine tout risque de manquer l'embarquement en cas de retard.",
        opts: {
          direct:      { l: "Direct uniquement",   s: "Aucune escale pour sécuriser l'embarquement" },
          connections: { l: "Correspondances OK",  s: "Plus d'options, souvent moins cher" },
          any:         { l: "Peu importe",          s: "L'IA optimise le prix" },
        },
      },
      origin_airport: {
        q:   "D'où partez-vous en avion ?",
        sub: "Nous utiliserons cet aéroport pour trouver les vols les moins chers.",
      },
      overnight: {
        q:   "Arriver la veille du départ ?",
        sub: "Fortement recommandé — un retard de vol peut faire rater l'embarquement.",
        opts: {
          yes: { l: "Oui, avec hôtel",   s: "Hôtel avec navette vers le port incluse" },
          no:  { l: "Non, le jour même", s: "Prévoyez un vol tôt le matin" },
        },
      },
      hotel_stars: {
        q:   "Quelle catégorie d'hôtel ?",
        sub: "Pour votre nuit avant l'embarquement — tous avec navette aéroport ou port.",
        opts: {
          budget:   { l: "Budget  2★",       s: "Propre et fonctionnel — meilleur prix" },
          midrange: { l: "Bon rapport  3★",  s: "Confort standard — meilleur rapport qualité-prix" },
          upscale:  { l: "Confort  4★+",     s: "Qualité supérieure — service soigné" },
        },
      },
      budget: {
        q:   "Quel est votre budget total ?",
        sub: "En dollars canadiens, pour tout le groupe, transport inclus.",
      },
    },

    // ── Airports ───────────────────────────────────────────────────────────────
    airports: [
      { v: "YUL", icon: "🛫", l: "YUL — Montréal-Trudeau",        s: "Aéroport principal du Québec" },
      { v: "YQB", icon: "🛫", l: "YQB — Québec (Jean Lesage)",   s: "Hub de la Capitale-Nationale" },
      { v: "BTV", icon: "🚗", l: "BTV — Burlington (Vermont)",   s: "~1h30 de Montréal — si vous êtes prêt à conduire, les prix sont souvent très compétitifs" },
      { v: "PLB", icon: "🚗", l: "PLB — Plattsburgh (New York)", s: "~1h de Montréal — vols à bas prix vers les ports du Sud" },
      { v: "other", icon: "✈️", l: "Autre aéroport",             s: "Préciser le code IATA ou la ville" },
    ],
    airport_other_placeholder: "ex: YOW, Ottawa, YYZ…",
    airport_other_hint:        "💡 Le code IATA (ex: YOW, YYZ) donne les meilleurs résultats de recherche.",

    // ── Generic ship classes ───────────────────────────────────────────────────
    generic_ship_classes: [
      { v: "mega",   l: "Méga-paquebot",  pax: "5 000+ passagers", s: "Ville flottante complète — toboggans géants, Broadway, 20+ restos, quartiers thématiques. Idéal famille active. (Icon, Oasis, World Europa, Excel)", icon: "🏙️" },
      { v: "large",  l: "Grand navire",   pax: "3 000–5 000 passagers", s: "Animation soutenue, diversité d'activités, excellent rapport qualité-prix. Le juste milieu. (Escape, Mardi Gras, Quantum, Vista)", icon: "🚢" },
      { v: "medium", l: "Navire moyen",   pax: "< 3 000 passagers", s: "Ambiance plus intime, moins de files d'attente, cuisine soignée. Parfait adultes & couples. (Prima, Edge Class, Rotterdam, Scarlet Lady)", icon: "⛵" },
      { v: "any",    l: "Peu importe",    pax: "Toutes tailles",    s: "Je veux la meilleure offre disponible — laissez l'IA choisir.", icon: "🎯" },
    ],

    // ── Results ────────────────────────────────────────────────────────────────
    results_title:       "Vos croisières idéales",
    results_subtitle:    "Classées selon vos priorités · Prix total groupe inclus",
    results_book_cruise: "Réserver cette croisière",
    results_book_hotel:  "Réserver l'hôtel sur Expedia →",
    results_hotel_support: "✓ Réserver via ce lien soutient directement Croisière AI",
    results_hotel_alt_book: "🏨 Réserver cet hôtel sur Expedia →",
    results_estimated:   "prix estimé",
    results_watch_price: "🔔 Surveiller ce prix",
    results_watch_cta:   "Activer la vigie →",
    results_watch_pro:   "À VENIR",
    results_watch_upsell:"🔜 Vigie de prix automatique — bientôt disponible",
    watch_modal_price_label:      "Prix que vous avez payé ($ CAD)",
    watch_modal_price_placeholder:"ex: 3 200",
    watch_modal_not_booked:       "Je n'ai pas encore réservé",
    watch_modal_tip:              "💡 Si le prix baisse après réservation, appelez la compagnie — ils ajustent presque toujours.",
    watch_modal_activating:       "Activation…",
    watch_modal_success_ship:     "Nous surveillons",
    watch_modal_success_for:      "pour vous.",
    watch_modal_success_sub:      "Vous recevrez un courriel dès qu'une baisse de prix est détectée.",
    watch_modal_spam:             "⚠️ Si vous ne recevez pas le courriel de confirmation, vérifiez votre dossier spam.",
    upsell_watch_title:           "🔔 Vigie de prix — Bientôt disponible",
    upsell_watch_savings:         "Les prix des croisières peuvent chuter de 15-30% dans les 60 jours avant le départ.",
    upsell_watch_desc:            "La vigie surveillera automatiquement le prix chaque semaine et vous alertera par courriel dès qu'une baisse est détectée. Fonctionnalité en développement — disponible prochainement.",
    upsell_watch_includes:        "🔧 En développement — incluse dans le futur Plan Pro. Restez à l'affût !",
    upsell_watch_cta:             "Compris",
    upsell_watch_cancel:          "Fermer",
    results_ask_question:"💬 Poser une question sur cette offre",
    results_refine:      "🔄 Affiner ma recherche",
    results_new_search:  "+ Nouvelle recherche",
    results_show_more:   "Voir plus d'offres",
    results_rank:        (n) => `Offre #${n}`,
    results_why:         "Pourquoi cette offre ?",
    results_itinerary:   "Itinéraire",
    results_cabin_opts:  "Options cabine",
    results_total:       "Total estimé",
    results_per_person:  "/ pers.",
    results_nights:      "nuits",
    results_hotel_label: "Hôtel la veille",
    results_flight_label:"Vol",
    results_flight_direct: "direct",
    results_flight_stop: (n) => `${n} escale${n > 1 ? "s" : ""}`,
    results_same_day_risk: "⚠️ Vol le jour de l'embarquement — Risque de manquer le bateau si retard. Voir alternative.",
    results_alt_flight:  "▸ Voir alternative vol",
    results_alt_hotel:   "▸ Voir alternative hôtel",
    results_shuttle_airport: "navette aéroport ✓",
    results_shuttle_port:    "navette port ✓",
    results_shuttle_check:   "vérifier navettes",
    results_filtered:        "Filtré : navette aéroport · navette port incluse",
    results_flight_search:   "✈️ Rechercher ce vol sur Expedia →",

    // ── Refinement modal ───────────────────────────────────────────────────────
    refine_title:    "Qu'est-ce qui ne vous convient pas ?",
    refine_cheaper:  { l: "💰 Trop cher",         s: "Chercher des alternatives moins coûteuses" },
    refine_dest:     { l: "🗺️ Destination",        s: "Je voudrais une autre région" },
    refine_ship:     { l: "🚢 Le navire",           s: "Je préfère un autre type de bateau" },
    refine_dates:    { l: "📅 Les dates",           s: "Chercher d'autres périodes" },
    refine_confirm:  "Relancer la recherche →",
    refine_cancel:   "Annuler",

    // ── Errors ─────────────────────────────────────────────────────────────────
    error_prefix:    "Erreur : ",
    error_retry:     "Réessayer",
    error_ai_empty:  "[951] Réponse IA vide. Réessayez dans quelques instants.",

    // ── Intro popup ────────────────────────────────────────────────────────────
    intro_title:   "Comment ça fonctionne",
    intro_steps: [
      { icon: "💬", title: "Décrivez votre voyage idéal", desc: "Budget, dates, style, destinations — répondez à quelques questions rapides." },
      { icon: "🔍", title: "L'IA cherche en temps réel",  desc: "Claude analyse les prix du jour sur les sites officiels des compagnies." },
      { icon: "🚢", title: "Offres sur mesure",         desc: "Les meilleures selon vos priorités, avec vols et hôtel la veille inclus." },
    ],
    intro_cta: "C'est parti →",

    // ── Prompt (system + user) — Claude répond en français ────────────────────
    system_msg: "Tu es un expert en croisières. Tu effectues des recherches web, puis tu livres TOUJOURS ton résultat final via le tool 'return_cruise_offers'. Tu ne réponds JAMAIS en texte libre — toujours via ce tool. Tous les champs texte du tool doivent être en français.",
  },

  // ════════════════════════════════════════════════════════════════════════════
  // ENGLISH
  // ════════════════════════════════════════════════════════════════════════════
  en: {
    app_title:   "Cruise AI",
    app_tagline: "Your AI travel agent — cruise, flights & hotel in minutes.",
    live_badge:  "LIVE",

    // ── Welcome ────────────────────────────────────────────────────────────────
    welcome_hero_alt: "Cruise port",
    welcome_start:    "📋 Answer a few questions →",
    welcome_how:      "How would you like to start?",
    welcome_form_sub: "Guided form · ~8 questions",
    welcome_or:       "or",
    welcome_cta_sub:  "✓ 2 free searches/month · 1st needs no account",
    welcome_bullets: [
      "🔍 Real-time web search — today's prices, not a catalogue",
      "✈️ Flights + pre-cruise hotel included in every recommendation",
      "🧠 The best offers for your criteria, ranked and explained",
    ],
    welcome_disclaimer: "No credit card required · Powered by Claude (Anthropic)",

    // ── Searching screen ───────────────────────────────────────────────────────
    searching_cruise:   "Searching for cruises",
    searching_cruise_d: "Analyzing availability and live prices…",
    searching_footer:   "Our AI verifies every cruise in real time — this can take up to a minute. Please don't refresh the page, we're almost there!",
    searching_flights:  "Searching for flights",
    searching_flights_d:"Best airfares to the departure port…",
    searching_hotel:    "Searching for hotel",
    searching_hotel_d:  "Hotels with airport and cruise port shuttle…",
    searching_results:  "Analyzing and preparing results",
    searching_results_d:"Comparing, ranking and formatting your selection…",
    searching_cancel:   "Cancel",
    analyse_steps: [
      "Comparing itineraries and ports of call…",
      "Checking the real price of each departure…",
      "Pricing flights and the night-before hotel…",
      "Ranking the best offers for you…",
      "Writing your personalized analysis…",
    ],

    // ── Tips ───────────────────────────────────────────────────────────────────
    tips: [
      "💡 Booking 6–9 months in advance usually gets the best prices — especially for larger cabins.",
      "💡 Tuesday and Wednesday are the best days to find flash sales.",
      "💡 CruiseDirect offers the same benefits as Costco Travel — without needing a Costco membership.",
      "💡 Interior cabins can cost 40% less — ideal if you spend your days exploring ports.",
      "💡 On a mega-ship, a Boardwalk balcony overlooks the theme park area — very lively at night.",
      "💡 Arriving the day before embarkation avoids flight-delay stress — a hotel night well spent.",
      "💡 Royal Caribbean's 'Kids Sail Free' promotions can save families thousands of dollars.",
      "💡 If you live near a port, driving eliminates the cost of flights entirely.",
    ],

    // ── Funnel navigation ──────────────────────────────────────────────────────
    next:            "Next →",
    back:            "← Back",
    search:          "🔍 Search now",
    select_multiple: "Select all that apply",
    optional:        "(optional)",
    skip:            "Skip",

    // ── Funnel steps ───────────────────────────────────────────────────────────
    steps: {
      experience: {
        q:   "What is your cruise experience?",
        sub: "This guides our search approach.",
        opts: {
          first:  { l: "First cruise",        s: "I've never sailed before" },
          some:   { l: "A few cruises",        s: "2 to 4 experiences" },
          expert: { l: "Seasoned cruiser",     s: "5 or more cruises" },
        },
      },
      vibe: {
        q:   "What vibe are you looking for?",
        sub: "We'll pick the best cruise line for your style.",
        opts: {
          party:     { l: "Party & lively",  s: "Pools, shows, bars" },
          family:    { l: "Family",           s: "Activities for all ages" },
          romantic:  { l: "Romantic",         s: "Refined, peaceful, gourmet" },
          adventure: { l: "Adventure",        s: "Sports, excursions, nature" },
        },
      },
      intent: {
        q:   "Anything specific in mind?",
        sub: "The priorities you'll rank later will guide Claude.",
        opts: {
          value:   { l: "I'm open to anything",  s: "Surprise me — the priorities I rank will guide the search" },
          company: { l: "A cruise line in mind", s: "There's a line I want to explore" },
          by_ship: { l: "A specific ship",       s: "I know exactly which ship I want" },
        },
      },
      regions: {
        q:   "Which destination appeals to you?",
        sub: "Select one or more regions.",
        opts: {
          carib_east:  { l: "Eastern Caribbean",  s: "Puerto Rico, USVI, St. Martin, Bahamas" },
          carib_west:  { l: "Western Caribbean",  s: "Mexico, Jamaica, Grand Cayman, Belize" },
          carib_south: { l: "Southern Caribbean", s: "Aruba, Curaçao, Barbados, Windward Islands" },
          repositioning: { l: "Repositioning / Crossing", s: "One-way, seasonal (spring/fall), limited departures" },
          bermuda:     { l: "Bermuda",             s: "Unique island, turquoise waters, British charm" },
          europe_med:     { l: "Mediterranean",            s: "Barcelona, Rome, Greece, Croatia" },
          europe_north:   { l: "Northern Europe & Baltic", s: "Copenhagen, Stockholm, Norwegian fjords" },
          europe_british: { l: "British Isles & Iceland",  s: "UK, Ireland, Reykjavik" },
          alaska:      { l: "Alaska",              s: "Glaciers, fjords, wildlife" },
          hawaii:      { l: "Hawaii / Pacific",    s: "Hawaiian islands, Polynesia" },
          asia:        { l: "Asia",                s: "Japan, Vietnam, Singapore, Dubai" },
          any:         { l: "Anywhere",            s: "Surprise me — best available deal" },
        },
      },
      ports: {
        q:   "A specific island or port of call?",
        sub: "Optional — e.g. Aruba, Curaçao, Bonaire. Leave blank if no preference.",
      },
      sea_days_pref: {
        q:   "Ports or sea days — your preference?",
        sub: "Two identical cruises can offer very different rhythms.",
        opts: {
          max_ports: { l: "Maximum ports",         s: "1–2 sea days max — explore every stop" },
          balanced:  { l: "Balanced",               s: "Mix of ports and relaxation at sea" },
          sea_days:  { l: "Sea days welcome",       s: "I enjoy the ship as much as the ports" },
          any:       { l: "No preference",          s: "Overall itinerary matters most" },
        },
      },
      port_activities: {
        q:   "What do you enjoy doing in ports?",
        sub: "Guides itinerary selection — select all that apply.",
        opts: {
          beach:     { l: "Beach & swimming",    s: "Sand, snorkeling, crystal waters" },
          culture:   { l: "History & culture",   s: "Historic sites, colonial towns, museums" },
          food:      { l: "Local cuisine",        s: "Markets, restaurants, authentic food" },
          shopping:  { l: "Shopping",             s: "Duty-free, local crafts, boutiques" },
          adventure: { l: "Sports & adventure",  s: "Kayaking, hiking, diving, zip-lining" },
          any:       { l: "All of the above",    s: "I decide based on what's available" },
        },
      },
      companies: {
        q:   "Any cruise line in mind?",
        sub: "Leave empty to search all cruise lines.",
      },
      company_for_ship: {
        q:   "Which cruise line?",
        sub: "Narrows down the ship list — skip if you're not sure.",
      },
      specific_ship: {
        q:   "Which ship are you targeting?",
        sub: "Select the ship you're interested in.",
      },
      ship_class: {
        q:   "Which ship class appeals to you?",
        sub: "The class determines atmosphere, activities and onboard vibe.",
      },
      ship_freshness: {
        q:   "Does the ship's condition matter to you?",
        sub: "A modern or recently renovated ship changes the on-board experience.",
        opts: {
          recent: { l: "Modern or renovated", s: "Launched or refit within the last 5 years" },
          any:    { l: "Doesn't matter",      s: "A great deal on an older ship is OK" },
        },
      },
      cabin: {
        q:   "What type of cabin do you prefer?",
        sub: "You can select multiple options.",
        opts: {
          balcony_ocean:       { l: "Ocean Balcony",  s: "Sea view" },
          balcony_centralpark: { l: "Central Park",   s: "Indoor garden view" },
          balcony_boardwalk:   { l: "Boardwalk",      s: "Theme park view" },
          oceanview:           { l: "Ocean View",     s: "Window, no balcony" },
          inside:              { l: "Interior",       s: "For exceptional deals" },
          suite:               { l: "Suite",          s: "Special occasion" },
        },
      },
      priorities: {
        q:   "Rank these criteria from most to least important.",
        sub: "Click in order — your #1 drives our scoring.",
        opts: {
          prix:       { l: "Price / Budget",  s: "Best value for money" },
          itineraire: { l: "Itinerary",       s: "Ports, destinations, stops" },
          bateau:     { l: "The ship",        s: "Class, size, freshness" },
          compagnie:  { l: "The cruise line", s: "Loyalty, style, onboard service" },
          experience: { l: "On-board experience", s: "Atmosphere, activities, dining" },
        },
      },
      duration: {
        q:   "How long a cruise?",
        sub: "Duration significantly affects the price.",
        opts: {
          short: { l: "Short  3–6 nights",   s: "Extended long weekend" },
          week:  { l: "7 nights exactly",    s: "The classic duration" },
          long:  { l: "Long  8+ nights",     s: "Immersive voyage" },
          xlong: { l: "15+ nights",          s: "Extended voyage" },
          any:   { l: "No preference",       s: "Best available deal" },
        },
        exactLabel: "Or specify exact number of nights:",
        exactPlaceholder: "e.g. 14",
        exactHint: "Search centered on this exact count (±1 night). Overrides the selection above.",
      },
      when: {
        q:   "When do you want to travel?",
        sub: "Your dates influence available promotions.",
        opts: {
          exact:    { l: "Exact dates",          s: "I know when I'm going" },
          flexible: { l: "Flexible ±1–3 days",  s: "Around my dates" },
          month:    { l: "A specific month",     s: "I'm targeting a period" },
          range:    { l: "A date range",         s: "Between two dates — e.g. July to August" },
          anytime:  { l: "Best available deal",  s: "Surprise me!" },
        },
      },
      dates: {
        q:   "What are your dates?",
        sub: "Select your departure date.",
      },
      group: {
        q:   "Who is traveling with you?",
        sub: "Every traveler counts for promotions.",
        opts: {
          solo:   { l: "Solo",    s: "Just me" },
          couple: { l: "Couple", s: "2 adults" },
          family: { l: "Family", s: "With children" },
          group:  { l: "Group",  s: "Friends / extended family" },
        },
      },
      group_size: {
        q:   "How many adults in the group?",
        sub: "Determines pricing and connecting cabin options.",
        opts: {
          "3":  { l: "3 adults",    s: "" },
          "4":  { l: "4 adults",    s: "Connecting cabins possible" },
          "6":  { l: "5–6 adults",  s: "Group rates available" },
          "8":  { l: "7–8 adults",  s: "Advantageous group rates" },
          "10": { l: "9+ adults",   s: "Group rates — contact an agency" },
        },
      },
      family_detail: {
        q:   "Tell me about your children.",
        sub: "Ages determine available promotions.",
      },
      cabin_occupancy: {
        q:   "One cabin or several?",
        sub: "From 3 travellers on, this changes which ships work and the price per person.",
        opts: {
          one:      { l: "A single cabin",     s: "Everyone in the same cabin" },
          multiple: { l: "Several cabins",     s: "Split across two cabins or more" },
          unsure:   { l: "Not sure yet",       s: "Show me the options" },
        },
      },
      occasion: {
        q:   "Is there a special occasion?",
        sub: "We'll tailor cabin and cruise line recommendations.",
        opts: {
          honeymoon:   { l: "Honeymoon",       s: "Wedding trip or first anniversary" },
          anniversary: { l: "Anniversary",     s: "Romantic occasion" },
          birthday:    { l: "Birthday / Celebration", s: "Family or friends celebration" },
          graduation:  { l: "Graduation / Retirement", s: "Major life milestone" },
          none:        { l: "No occasion",     s: "Regular trip" },
        },
      },
      departure: {
        q:   "How will you get to the port?",
        sub: "Determines our search sources.",
        opts: {
          drive_ny:  { l: "Drive",        s: "I'll drive to the port" },
          fly_south: { l: "Fly",          s: "AI finds the best flights" },
          either:    { l: "Either",       s: "Compare both options" },
        },
      },
      departure_port: {
        q:   "Which departure port works for you?",
        sub: "Choose the port your cruise will depart from.",
      },
      infant_flight_seat: {
        q:   "For the flight, how will your infant travel?",
        sub: "Under 2: on a parent's lap (often free or taxes only) or in a booked seat. Children 2 and older always take their own seat.",
        opts: {
          lap:  { l: "On a parent's lap", s: "Often free (domestic) or taxes only" },
          seat: { l: "In a booked seat",  s: "Infant counted as a passenger (paid seat)" },
        },
      },
      drive_origin: {
        q:   "Where are you located?",
        sub: "So we can suggest one drivable option and one fly-to option.",
        opts: {
          mtl:    { l: "Montreal / Quebec City", s: "Cape Liberty, NY and Boston within ~5–7h drive" },
          ottawa: { l: "Ottawa / Kingston",       s: "Cape Liberty, NY and Boston within ~6–8h drive" },
          toronto:{ l: "Toronto / Ontario",       s: "Northeast ports are 9h+ — better to fly" },
          autres: { l: "Other region",            s: "All options by flight" },
        },
      },
      flight_type: {
        q:   "What type of flight do you prefer?",
        sub: "Nonstop eliminates any risk of missing embarkation if delayed.",
        opts: {
          direct:      { l: "Nonstop only",      s: "No connections to secure embarkation" },
          connections: { l: "Connections OK",    s: "More options, often cheaper" },
          any:         { l: "No preference",     s: "AI optimizes the price" },
        },
      },
      origin_airport: {
        q:   "Where are you flying from?",
        sub: "We'll use this airport to find the cheapest flights.",
      },
      overnight: {
        q:   "Arrive the night before departure?",
        sub: "Strongly recommended — a flight delay can mean missing the ship.",
        opts: {
          yes: { l: "Yes, with hotel",   s: "Hotel with shuttle to the cruise port included" },
          no:  { l: "No, same day",      s: "Plan an early morning flight" },
        },
      },
      hotel_stars: {
        q:   "What hotel category?",
        sub: "For your night before embarkation — all include airport or port shuttle.",
        opts: {
          budget:   { l: "Budget  2★",       s: "Clean and functional — best price" },
          midrange: { l: "Good value  3★",   s: "Standard comfort — best value for money" },
          upscale:  { l: "Upscale  4★+",     s: "Superior quality — attentive service" },
        },
      },
      budget: {
        q:   "What is your total budget?",
        sub: "In Canadian dollars, for the entire group, transport included.",
      },
    },

    // ── Airports ───────────────────────────────────────────────────────────────
    airports: [
      { v: "JFK", icon: "🛫", l: "JFK — New York (Kennedy)",    s: "Major Northeast hub" },
      { v: "EWR", icon: "🛫", l: "EWR — Newark",                s: "New Jersey / New York area" },
      { v: "MIA", icon: "🛫", l: "MIA — Miami",                  s: "Closest to Florida cruise ports" },
      { v: "YUL", icon: "🛫", l: "YUL — Montreal (Trudeau)",    s: "Main Quebec airport" },
      { v: "YYZ", icon: "🛫", l: "YYZ — Toronto (Pearson)",     s: "Main Ontario hub" },
      { v: "BTV", icon: "🚗", l: "BTV — Burlington, VT",        s: "~1.5h from Montreal — often cheaper US fares worth the drive" },
      { v: "PLB", icon: "🚗", l: "PLB — Plattsburgh, NY",       s: "~1h from Montreal — budget US flights south" },
      { v: "other", icon: "✈️", l: "Other airport",             s: "Enter your IATA code or city" },
    ],
    airport_other_placeholder: "e.g. LAX, Chicago, ORD…",
    airport_other_hint:        "💡 IATA codes (e.g. LAX, ORD) give the most accurate search results.",

    // ── Generic ship classes ───────────────────────────────────────────────────
    generic_ship_classes: [
      { v: "mega",   l: "Mega-ship",     pax: "5,000+ passengers", s: "Floating city — giant water slides, Broadway shows, 20+ restaurants, themed neighborhoods. Perfect for active families. (Icon, Oasis, World Europa, Excel)", icon: "🏙️" },
      { v: "large",  l: "Large ship",    pax: "3,000–5,000 passengers", s: "Plenty of entertainment, diverse activities, excellent value. The sweet spot. (Escape, Mardi Gras, Quantum, Vista)", icon: "🚢" },
      { v: "medium", l: "Medium ship",   pax: "< 3,000 passengers", s: "More intimate atmosphere, shorter lines, refined dining. Perfect for adults & couples. (Prima, Edge Class, Rotterdam, Scarlet Lady)", icon: "⛵" },
      { v: "any",    l: "No preference", pax: "All sizes", s: "I want the best available deal — let AI choose.", icon: "🎯" },
    ],

    // ── Results ────────────────────────────────────────────────────────────────
    results_title:       "Your ideal cruises",
    results_subtitle:    "Ranked by your priorities · Total group price included",
    results_book_cruise: "Book this cruise",
    results_book_hotel:  "Book hotel on Expedia →",
    results_hotel_support: "✓ Booking via this link directly supports Cruise AI",
    results_hotel_alt_book: "🏨 Book this hotel on Expedia →",
    results_estimated:   "estimated price",
    results_watch_price: "🔔 Monitor this price",
    results_watch_cta:   "Set price alert →",
    results_watch_pro:   "SOON",
    results_watch_upsell:"🔜 Automatic price watch — coming soon",
    watch_modal_price_label:      "Price you paid (CAD $)",
    watch_modal_price_placeholder:"e.g. 3,200",
    watch_modal_not_booked:       "I haven't booked yet",
    watch_modal_tip:              "💡 If the price drops after booking, call the cruise line — they almost always match the new price.",
    watch_modal_activating:       "Activating…",
    watch_modal_success_ship:     "We are watching",
    watch_modal_success_for:      "for you.",
    watch_modal_success_sub:      "You'll receive an email as soon as a price drop is detected.",
    watch_modal_spam:             "⚠️ If you don't receive the confirmation email, please check your spam folder.",
    upsell_watch_title:           "🔔 Price Alert — Coming soon",
    upsell_watch_savings:         "Cruise prices can drop 15–30% in the 60 days before departure.",
    upsell_watch_desc:            "The price alert will automatically check prices every week and email you when a drop is detected. Feature in development — available soon.",
    upsell_watch_includes:        "🔧 In development — included in the upcoming Pro plan. Stay tuned!",
    upsell_watch_cta:             "Got it",
    upsell_watch_cancel:          "Close",
    results_ask_question:"💬 Ask a question about this offer",
    results_refine:      "🔄 Refine my search",
    results_new_search:  "+ New search",
    results_show_more:   "Show more offers",
    results_rank:        (n) => `Offer #${n}`,
    results_why:         "Why this offer?",
    results_itinerary:   "Itinerary",
    results_cabin_opts:  "Cabin options",
    results_total:       "Estimated total",
    results_per_person:  "/ person",
    results_nights:      "nights",
    results_hotel_label: "Night before hotel",
    results_flight_label:"Flight",
    results_flight_direct: "nonstop",
    results_flight_stop: (n) => `${n} stop${n > 1 ? "s" : ""}`,
    results_same_day_risk: "⚠️ Flight on embarkation day — Risk of missing the ship if delayed. See alternative.",
    results_alt_flight:  "▸ See flight alternative",
    results_alt_hotel:   "▸ See hotel alternative",
    results_shuttle_airport: "airport shuttle ✓",
    results_shuttle_port:    "port shuttle ✓",
    results_shuttle_check:   "verify shuttles",
    results_filtered:        "Filtered: airport shuttle · port shuttle included",
    results_flight_search:   "✈️ Search this flight on Expedia →",

    // ── Refinement modal ───────────────────────────────────────────────────────
    refine_title:    "What doesn't work for you?",
    refine_cheaper:  { l: "💰 Too expensive",    s: "Find cheaper alternatives" },
    refine_dest:     { l: "🗺️ Destination",      s: "I want a different region" },
    refine_ship:     { l: "🚢 The ship",          s: "I prefer a different type of ship" },
    refine_dates:    { l: "📅 The dates",         s: "Search other time periods" },
    refine_confirm:  "Search again →",
    refine_cancel:   "Cancel",

    // ── Errors ─────────────────────────────────────────────────────────────────
    error_prefix:    "Error: ",
    error_retry:     "Try again",
    error_ai_empty:  "[951] Empty AI response. Please try again in a moment.",

    // ── Intro popup ────────────────────────────────────────────────────────────
    intro_title:  "How it works",
    intro_steps: [
      { icon: "💬", title: "Describe your ideal trip", desc: "Budget, dates, style, destinations — answer a few quick questions." },
      { icon: "🔍", title: "AI searches in real time",  desc: "Claude analyzes today's prices on official cruise line websites." },
      { icon: "🚢", title: "Tailored offers",         desc: "The best for your priorities, with flights and pre-cruise hotel included." },
    ],
    intro_cta: "Let's go →",

    // ── Prompt (system + user) — Claude responds in English ───────────────────
    system_msg: "You are a cruise expert. You perform web searches, then ALWAYS deliver your final result via the 'return_cruise_offers' tool. You NEVER respond in plain text — always via the tool. All text fields in the tool must be in English.",
  },
};

// Helper: get strings for a given language
export function getStrings(lang) {
  return strings[lang] || strings.fr;
}
